<template lang="pug">
  sui-segment(vertical)
    sui-grid
      sui-grid-column
        sui-table(
          size="large",
          :columns="6",
          unstackable,
          single-line,
          selectable)
          sui-table-header
            sui-table-row
              sui-table-header-cell(
                colspan="2",
                text-align="center") Away
              sui-table-header-cell(
                colspan="2",
                text-align="center") Score
              sui-table-header-cell(
                colspan="2",
                text-align="center") Home

          sui-table-body
            match-row(
              v-for="match in matches",
              :key="match.matchId",
              @click="$emit('selectMatch', $event)",
              :match="match")
</template>

<script>
import MatchRow from '@/components/matches/MatchRow.vue';

export default {
  name: 'MatchesTable',
  components: {
    MatchRow,
  },
  props: {
    matches: {
      required: true,
    },
  },
};
</script>
